import { isAssetUrl } from '../../utils/assetUrl';

export const DEFAULT_EMOJI_DISH_SIZE = 84;
export const DEFAULT_PHOTO_DISH_SIZE = 96;
const MIN_DISH_SIZE = 28;

const normalizeSize = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

export const getDefaultDishDimensions = (dish = {}) => {
  const fallbackSize = isAssetUrl(dish.icon) ? DEFAULT_PHOTO_DISH_SIZE : DEFAULT_EMOJI_DISH_SIZE;
  const width = normalizeSize(dish.width);
  const height = normalizeSize(dish.height);
  const resolvedWidth = width ?? height ?? fallbackSize;
  const resolvedHeight = height ?? width ?? fallbackSize;

  return {
    width: Math.max(resolvedWidth, MIN_DISH_SIZE),
    height: Math.max(resolvedHeight, MIN_DISH_SIZE),
  };
};
